{
  "_comment": "[CI-LOCKED] Obsah tohoto souboru je uzamčen. Příspěvky jsou vítány, ale ověření změny může být zpožděno.",
  "ACCESS_KEY_ALT": "Alt + Shift + $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control + Option + $1",
  "ACTIVITY_BOT_SAID_ALT": "Robot $1 řekl:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Agent",
  "ACTIVITY_YOU_SAID_ALT": "Řekli jste:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Robot byl připojen:",
  "ACTIVITY_CODE_ALT": "Ukázka kódu: $1",
  "ACTIVITY_CONTENT_CAUTION": "Obsah vygenerovaný AI může být nesprávný.",
  "ACTIVITY_CODE_CAUTION": "Kód vygenerovaný AI. Zkontrolujte ho a používejte s obezřetností.",
  "ACTIVITY_ERROR_BOX_TITLE": "Chybová zpráva",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Kliknutím provedete interakci.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "Zpráva je interaktivní.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "Zpráva obsahuje nejméně jeden odkaz.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Odeslání se nezdařilo.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Připojili jste:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 příloha",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 přílohy",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 příloh",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 příloh",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 přílohy",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Odeslání se nezdařilo. [Opakovat][RETRY]",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Odesílání",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "Odesláno v $1",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Právě teď",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Před 1 hodinou",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Před 1 minutou",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Dnes",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Včera",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Chyba analyzování adaptivní karty",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Chyba vykreslování adaptivní karty",
  "ATTACHMENT_AUDIO": "Zvukový klip",
  "ATTACHMENT_CARD": "Karta: $1 $2 $3",
  "ATTACHMENT_FILE": "Soubor: $1",
  "ATTACHMENT_IMAGE": "Obrázek",
  "ATTACHMENT_TEXT": "Text: $1",
  "ATTACHMENT_VIDEO": "Videoklip",
  "AVATAR_ALT": "Avatar robota $1",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Další",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Předchozí",
  "CITATION_MODEL_DIALOG_ALT": "Citace",
  "CLOSE_BUTTON_ALT": "Zavřít",
  "COLLAPSIBLE_GROUPING_TITLE": "Přemýšlím…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "To se zobrazí, když bot vytváří zprávy odpovědí ve skupině, pokud není k dispozici žádný abstrakt.",
  "COLLAPSE_BUTTON_LESS": "Zobrazit méně",
  "COLLAPSE_BUTTON_LESS.comment": "Toto je text tlačítka se šipkou pro sbalení skupiny zpráv. Když koncový uživatel klikne na tlačítko, skupina zpráv se sbalí.",
  "COLLAPSE_BUTTON_MORE": "Zobrazit více",
  "COLLAPSE_BUTTON_MORE.comment": "Toto je text tlačítka se šipkou pro rozbalení skupiny zpráv. Když koncový uživatel klikne na tlačítko, skupina zpráv se rozbalí.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Připojeno",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Připojování…",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Nelze navázat připojení.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Došlo k přerušení sítě. Znovu se připojuje…",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "Chyba vykreslování. Zkontrolujte konzolu nebo kontaktujte vývojáře botů.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Připojení trvá déle než obvykle.",
  "CONNECTIVITY_STATUS_ALT": "Stav připojení: $1",
  "COPY_BUTTON_TEXT": "Kopírovat",
  "COPY_BUTTON_COPIED_TEXT": "Zkopírováno",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Odeslat",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "Zrušit",
  "FEEDBACK_FORM_PLACEHOLDER": "Zadejte co nejvíce podrobností, ale neuvádějte žádné soukromé nebo citlivé informace.",
  "FEEDBACK_FORM_TITLE": "Řekněte nám o své zkušenosti",
  "FILE_CONTENT_ALT": "$1",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "Stáhnout soubor $1",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "Stáhnout soubor $1 o velikosti $2",
  "FILE_CONTENT_WITH_SIZE_ALT": "$1 o velikosti $2",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Otevře se v novém okně; externí.",
  "RECEIPT_CARD_TAX": "Daň",
  "RECEIPT_CARD_TOTAL": "Celkem",
  "RECEIPT_CARD_VAT": "DPH",
  "REFERENCE_LIST_HEADER_ONE": "$1 odkaz",
  "REFERENCE_LIST_HEADER_FEW": "$1 odkazy",
  "REFERENCE_LIST_HEADER_MANY": "$1 odkazů",
  "REFERENCE_LIST_HEADER_OTHER": "$1 odkazů",
  "REFERENCE_LIST_HEADER_TWO": "$1 odkazy",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "Odstranit přílohu $1",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Odstranit",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Soubor",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Obrázek",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Prázdnou zprávu nelze odeslat.",
  "SPEECH_INPUT_LISTENING": "Naslouchání…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon vypnout",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon zapnout",
  "SPEECH_INPUT_STARTING": "Spouštění…",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Další",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Předchozí",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Navrhované akce",
  "TEXT_INPUT_ALT": "Pole pro zadání zprávy",
  "TEXT_INPUT_PLACEHOLDER": "Zadejte svou zprávu",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Začněte mluvit…",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Poslouchám…",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "Probíhá zpracování…",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Promluvením přerušíte…",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Odeslat",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Mluvit",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Nahrát soubor",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Klávesnice telefonu",
  "TEXT_INPUT_DROP_ZONE": "Přetáhněte soubory",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "Byla překročena délka zprávy.",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Podporuje pouze jednociferný vstup.",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 přílohy",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 příloh",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 příloha",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 příloh",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 přílohy",
  "TOAST_ACCORDION_FEW": "$1 oznámení: kliknutím sem zobrazíte podrobnosti.",
  "TOAST_ACCORDION_MANY": "$1 oznámení: kliknutím sem zobrazíte podrobnosti.",
  "TOAST_ACCORDION_OTHER": "$1 oznámení: kliknutím sem zobrazíte podrobnosti.",
  "TOAST_ACCORDION_TWO": "$1 oznámení: kliknutím sem zobrazíte podrobnosti.",
  "TOAST_ALT_ERROR": "Chyba",
  "TOAST_ALT_INFO": "Informace",
  "TOAST_ALT_SUCCESS": "Úspěch",
  "TOAST_ALT_WARN": "Upozornění",
  "TOAST_DISMISS_BUTTON": "Zavřít",
  "TOAST_TITLE_ALT": "Oznámení",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Historie chatu, k navigaci použijte šipkové klávesy.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "historie chatu",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Zpráva je interaktivní. Dvojím až trojím stisknutím kláves Shift + tabulátor přejdete do historie chatu. Interakci zahájíte kliknutím na zprávu.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Zpráva obsahuje nejméně jeden odkaz. Dvojím až trojím stisknutím kláves Shift + tabulátor přejdete do historie chatu. Interakci zahájíte kliknutím na zprávu.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "Zpráva obsahuje navrhované akce. Pokud je chcete vybrat, stiskněte 2 až 3krát klávesy Shift + tabulátor.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "Zpráva obsahuje navrhované akce. Pokud je chcete vybrat, stiskněte klávesu $1.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "Zprávu se nepodařilo odeslat.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "K dispozici jsou nové zprávy. Stisknutím $1 umístíte fokus na tlačítko $2.",
  "TRANSCRIPT_MORE_MESSAGES": "Další zprávy",
  "TRANSCRIPT_NEW_MESSAGES": "Nové zprávy",
  "TRANSCRIPT_TERMINATOR_TEXT": "Konec historie chatu",
  "TYPING_INDICATOR_ALT": "Zobrazuje se indikátor psaní",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 píše.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 a další píšou.",
  "VIEW_CODE_BUTTON_TEXT": "Kód",
  "VOTE_COMPLETE_ALT": "Názory byly zaznamenány.",
  "VOTE_COMPLETE_ALT.comment": "Určeno pro čtečku obrazovky. Popisek tlačítka s ikonami palce nahoru a dolů. Popisek se používá při zaznamenávání názorů.",
  "VOTE_DISLIKE_ALT": "To se mi nelíbí",
  "VOTE_LIKE_ALT": "To se mi líbí"
}